import React, { useEffect } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import { Typography } from "@progress/kendo-react-common";
import { requiredValidator } from "../../../components/formFields/CommonValidator";
import ShadowCard from "../../../components/common/ShadowCard";
import FormDatePicker from "../../../components/formFields/FormDateField";
import moment from "moment";
import { getAllActiveUsers } from "../../user/services/user.services";
// import { IUser } from "../../user/userModel";
import { ILeadSource } from "../../leadsource/leadsourceModel";
import { getAllActiveLeadSource } from "../../leadsource/services/leadsource.service";
import { getAllActiveLeadStage } from "../../leadstage/services/leadStage.services";
import { ILeadStage } from "../../leadstage/leadStageModel";
import { FOLLOWUPSTATUS, INQUIRYQUERIES } from "../../../_contstants/common";
import { ISector } from "../../sector/sectorModel";
import { getAllActiveSectors } from "../../sector/services/sector.services";
import { IUser } from "../../user/userModel";

interface ChangeWatcherProps {
  formRenderProps: FormRenderProps;
}

const ChangeWatcher: React.FC<ChangeWatcherProps> = ({ formRenderProps }) => {
  useEffect(() => {
    formRenderProps.onChange("filterFromDate", {
      value: moment().startOf("month").toDate(),
    });
    formRenderProps.onChange("filterToDate", {
      value: moment().toDate(),
    });
  }, []);
  return null;
};

const InquiryReportForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.reports.loading);
  const UserList = useAppSelector((state) => state.user.UserList);
  const LeadSourceList = useAppSelector(
    (state) => state.leadsource.LeadSourceList
  );
  const LeadStageList = useAppSelector(
    (state) => state.leadStage.LeadStageList
  );
  const SectorList = useAppSelector((state) => state.sector.SectorList);

  useEffect(() => {
    dispatch(getAllActiveUsers());
    dispatch(getAllActiveSectors());
    dispatch(getAllActiveLeadSource());
    dispatch(getAllActiveLeadStage("INQUIRY"));
  }, []);

  const handleSubmit = (values: any) => {
    const payload: any = {};

    payload.filterFromDate = values?.filterFromDate
      ? moment(values?.filterFromDate).format("YYYY-MM-DD")
      : "0";
    payload.filterToDate = values?.filterToDate
      ? moment(values?.filterToDate).format("YYYY-MM-DD")
      : "0";
    payload.filterAssignedTo = values?.filterAssignedTo
      ? values?.filterAssignedTo
      : "0";
    payload.filterRequirementType = values?.filterRequirementType
      ? values?.filterRequirementType
      : "0";
    payload.filterDestination = values?.filterDestination
      ? values?.filterDestination
      : "0";
    payload.filterInquiryStageID = values?.filterInquiryStageID
      ? values?.filterInquiryStageID
      : "0";
    payload.filterInquiryStatus = values?.filterInquiryStatus
      ? values?.filterInquiryStatus
      : "0";
    payload.filterInquirySourceID = values?.filterInquirySourceID
      ? values?.filterInquirySourceID
      : "0";

    window.open(
      `inquiryreportview/${payload?.filterFromDate}/${payload?.filterToDate}/${payload?.filterRequirementType}/${payload?.filterDestination}/${payload?.filterInquiryStageID}/${payload?.filterInquiryStatus}/${payload?.filterInquirySourceID}/${payload?.filterAssignedTo}`
    );
  };

  return (
    <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
      <GridLayoutItem>
        <ShadowCard>
          <Form
            onSubmit={handleSubmit}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ cols: 10, rows: 0 }}
                  cols={[{ width: "40%" }, { width: "30%" }, { width: "30%" }]}
                >
                  <GridLayoutItem colSpan={3}>
                    <Typography.h4
                      style={{ marginBottom: 0, marginLeft: "3px" }}
                    >
                      Inquiry Report
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem style={{ display: "flex", gap: 10 }}>
                    <Field
                      name="filterFromDate"
                      label="From Date"
                      format="dd/MM/yyyy"
                      wrapperStyle={{ width: "100%" }}
                      component={FormDatePicker}
                      astrike={true}
                      validator={requiredValidator}
                    />
                    <Field
                      name="filterToDate"
                      label="To Date"
                      format="dd/MM/yyyy"
                      minDate={moment(
                        formRenderProps.valueGetter("filterFromDate")
                      ).toDate()}
                      wrapperStyle={{ width: "100%" }}
                      component={FormDatePicker}
                      astrike={true}
                      validator={requiredValidator}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}></GridLayoutItem>
                  <GridLayoutItem style={{ display: "flex", gap: 10 }}>
                    <Field
                      name="filterRequirementType"
                      wrapperClassName="w-50"
                      label="Type"
                      placeholder="Type"
                      component={FormSelectionField}
                      options={INQUIRYQUERIES?.map((type: any) => ({
                        value: type?.value,
                        label: type?.label,
                      }))}
                    />
                    <Field
                      wrapperClassName="w-50"
                      id={"filterDestination"}
                      name={"filterDestination"}
                      label={"Destination"}
                      placeholder="Destination"
                      component={FormSelectionField}
                      options={SectorList?.map((sector: ISector) => {
                        return {
                          value: sector?.ID,
                          label: sector?.SectorName,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}></GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      id={"filterInquiryStatus"}
                      name={"filterInquiryStatus"}
                      label={"Inquiry Status"}
                      placeholder="Inquiry Status"
                      component={FormSelectionField}
                      options={FOLLOWUPSTATUS?.map((status: any) => {
                        return {
                          value: status.value,
                          label: status.label,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}></GridLayoutItem>
                  <GridLayoutItem style={{ display: "flex", gap: 10 }}>
                    <Field
                      wrapperClassName="w-100"
                      id={"filterInquirySourceID"}
                      name={"filterInquirySourceID"}
                      label={"Inquiry Source"}
                      placeholder="Inquiry Source"
                      component={FormSelectionField}
                      options={LeadSourceList?.map(
                        (leadsource: ILeadSource) => {
                          return {
                            value: leadsource?.ID,
                            label: leadsource?.Source,
                          };
                        }
                      )}
                    />
                    <Field
                      wrapperClassName="w-100"
                      id={"filterInquiryStageID"}
                      name={"filterInquiryStageID"}
                      label={"Inquiry Stage"}
                      placeholder="Inquiry Stage"
                      component={FormSelectionField}
                      options={LeadStageList?.map((leadstage: ILeadStage) => {
                        return {
                          value: leadstage?.ID,
                          label: leadstage?.LeadStage,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}></GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="filterAssignedTo"
                      label="Assigned User"
                      placeholder="Assigned User"
                      component={FormSelectionField}
                      options={UserList?.map((user: IUser) => ({
                        value: user?.ID,
                        label: `${user?.FirstName} ${user?.LastName}`,
                      }))}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}></GridLayoutItem>
                  <GridLayoutItem
                    style={{
                      display: "flex",
                      gap: 10,
                      position: "relative",
                      minHeight: 50,
                    }}
                  >
                    <div style={{ position: "absolute", top: 20, right: 0 }}>
                      <ButtonWithLoading
                        label={"Get Details"}
                        type="submit"
                        Size="medium"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                    </div>
                  </GridLayoutItem>
                  {/* <GridLayoutItem
                    style={{
                      position: "relative",
                      minHeight: 90,
                    }}
                  >
                    <div style={{ position: "absolute", top: 35, left: 0 }}>
                      <ButtonWithLoading
                        label={"Get Details"}
                        type="submit"
                        Size="medium"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                    </div>
                  </GridLayoutItem> */}
                </GridLayout>
                <ChangeWatcher formRenderProps={formRenderProps} />
              </FormElement>
            )}
          />
        </ShadowCard>
      </GridLayoutItem>
    </GridLayout>
  );
};

export default InquiryReportForm;
